/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, Input } from '@angular/core';
import { CompiledLicenseDTO } from '../../models/compiled-license-dto';

declare var $: any;

@Component({
  selector: 'app-view-compiled-license-dialog',
  templateUrl: './view-compiled-license-dialog.component.html'
})
export class ViewCompiledLicenseDialogComponent {

  @Input()
  mLicenseInfo: CompiledLicenseDTO;



  public showDialog(): void {
    $("#viewCompiledLicenseModal").modal("show");
  }

  public hideDialog(): void {
    $("#viewCompiledLicenseModal").modal("hide");
  }

  getEntityTypeLimits(): EntityTypeLimitUI[] {
    const rv: EntityTypeLimitUI[] = [];
    if (this.mLicenseInfo != null && this.mLicenseInfo.licensed_entity_type_limits != null) {
      for (const entityType of Object.keys(this.mLicenseInfo.licensed_entity_type_limits)) {
        const ui = new EntityTypeLimitUI();
        ui.mEntityType = entityType;
        ui.mLimit = this.mLicenseInfo.licensed_entity_type_limits[entityType];
        rv.push(ui);
      }
    }
    return rv;
  }

}

class EntityTypeLimitUI {
  mEntityType: string;
  mLimit: number;
}
